import React from 'react';
import PropTypes from 'prop-types';

import {IntlProvider} from 'react-intl';

import {getCurrentTranslation} from '../utils/translations.js';
import ActivityEntry from "../FilteredActivityList/ActivityList/ActivityEntry";
import Config from "../utils/config";

class ActivityList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        const {activities, colourTheme, cssClass} = this.props;
        const locale = Config.get('locale');


        return (
            <IntlProvider messages={getCurrentTranslation(locale)} locale={locale} defaultLocale="cs">
                <React.Fragment>
                    {activities.map((activity, index) => (
                        <div className={'p-2 activity-box ' + cssClass}>
                            <ActivityEntry
                                key={activity.id}
                                id={activity.id}
                                iterationIndex={index}
                                nameClass={activity.classLabel.name}
                                nameSubject={activity.subjectLabel.name}
                                nameSubtopic={activity.labelSubtopic?.name}
                                activityLink={activity.detailUrl}
                                activityName={activity.name}
                                activityType={{key: activity.type, name: activity.typeName}}
                                activityIntent={{key: activity.intent, name: activity.intentName}}
                                withEvaluation={activity.withEvaluation}
                                difficulty={activity.difficultyLevel}
                                seen={activity?.seen}
                                colourTheme={colourTheme ? colourTheme : activity.subjectLabel?.subjectColor}
                                subjectAbbreviation={activity.subjectLabel?.subjectAbbreviation}
                                blank={activity.blank}
                                hasPermission={activity.hasPermission}
                                inContentPack={activity.inContentPack}
                                automaticLanguages={activity.automaticLanguages}
                                isPcPreferred={activity.isPcPreferred}
                            />
                        </div>
                    ))}
                </React.Fragment>
            </IntlProvider>
        );
    }
}

ActivityList.propTypes = {
    activities: PropTypes.array.isRequired,
    colourTheme: PropTypes.string,
    cssClass: PropTypes.string,
};

export default ActivityList;
